export enum ExperimentalFeatureFlagType {
  UseHtmlInDatabaseTableView = 'use-html-in-database-table-view',
  ShowDatabaseViewsInSidebar = 'show-database-views-in-sidebar',
  UseUnifiedSpaceSwitcher = 'use-unified-space-switcher',
  UseUnifiedSettings = 'use-unified-settings',
  ShowUnreadNotificationCountInSidebar = 'show-unread-notification-count-in-sidebar',
  HideBottomSheetOverlay = 'hide-bottom-sheet-overlay',
  EnableEnhancedNotifications = 'enable-enhanced-notifications',
  EnableAiAutocompleteInDocuments = 'enable-ai-autocomplete-in-documents',
  EnableCollections = 'enable-collections',
  EnableWorkspaceSwitcherRail = 'enable-workspace-switcher-rail',
  EnableModernDatabaseViewHeader = 'enable-modern-database-view-header',
  EnableResourceHeaderSearch = 'enable-resource-header-search',
  EnableResourceTypeIconColors = 'enable-resource-type-icon-colors',
  EnableWatchersProperty = 'enable-watchers-property',
  EnableButtonProperty = 'enable-button-property',
  ShowCanvasFpsCounter = 'show-canvas-fps-counter',
}
